"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logRequest = exports.getLogger = void 0;
const web_log_1 = require("@snapchat/web-log");
function getLogger(requestID, req) {
    return req ? (0, web_log_1.withRequest)(requestID, req.method || "", req.url || "") : web_log_1.log;
}
exports.getLogger = getLogger;
function logRequest(req, res, appContext, log) {
    const { err } = appContext.ctx;
    if (req) {
        // When a request fails on the server, whether in a missing page or rendering,
        // next.js routes internally to /pages/_error or /pages/500 or /pages/404,
        // all of which run through this getInitialProps again with an updated res.statusCode.
        //
        // To preserve the original request's page name, add a fake sc-page-name header with that name
        //
        // Next.js renders a static page for /500 at build time, so sc-page-name for that
        // will always be ErrorPage.
        const Component = appContext.Component;
        const pageNameHeader = req.headers["sc-page-name"];
        const pageName = (typeof pageNameHeader === "string" && pageNameHeader) ||
            Component.displayName ||
            Component.name;
        req.headers["sc-page-name"] = pageName;
        const statusCode = res?.statusCode || 0;
        if (statusCode >= 500) {
            logServerError(log, req, pageName, statusCode);
        }
        else if (err || statusCode >= 400) {
            logServerWarning(log, req, pageName, statusCode);
        }
        else {
            logRequestInfo(log, req, pageName);
        }
    }
}
exports.logRequest = logRequest;
function logServerError(log, req, pageName, statusCode) {
    log.error(req.method, req.url, "page", pageName, "status", statusCode, req.headers);
}
function logServerWarning(log, req, pageName, statusCode) {
    log.warn(req.method, req.url, "page", pageName, "status", statusCode, req.headers);
}
function logRequestInfo(log, req, pageName) {
    log.info(req.method, req.url, "page", pageName, req.headers["user-agent"]);
}
//# sourceMappingURL=index.js.map